// extracted by mini-css-extract-plugin
export default {"BlogMainPage":"BlogMainPage_BlogMainPage__P81-O","BlogMainPage__heading":"BlogMainPage_BlogMainPage__heading__3boOp"};